/* eslint-disable import/prefer-default-export */

export const LOGIN_RESULT = 'login_result';
